module.exports = __webpack_public_path__ + "static/media/accesoires-huishoudelijk.c2b8da12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/accesoires-huishoudelijk.png
// module id = 325
// module chunks = 0